import React from 'react';
import { Section } from './Section';
export function ModulesSection() {
  const modules = [{
    icon: '📘',
    title: 'Módulo 1 — Entendé tu ansiedad nocturna',
    desc: 'Por qué tu mente se activa justo cuando querés dormir. El ciclo ansiedad-insomnio y cómo romperlo.'
  }, {
    icon: '📗',
    title: 'Módulo 2 — Reprogramá tu mente',
    desc: 'Técnicas de respiración, anclaje y reencuadre cognitivo para frenar los pensamientos en loop.'
  }, {
    icon: '📙',
    title: 'Módulo 3 — Tu ritual nocturno',
    desc: 'Cómo armar una rutina de cierre del día que le avise al sistema nervioso que puede soltar.'
  }, {
    icon: '📕',
    title: 'Módulo 4 — El ambiente importa',
    desc: 'Luz, temperatura, pantallas, sonidos — qué cambiar en tu cuarto y en tu noche.'
  }, {
    icon: '📓',
    title: 'Módulo 5 — Qué hacer cuando te despertás a las 3am',
    desc: 'Protocolo de rescate para volver a dormirse sin angustiarse.'
  }, {
    icon: '📔',
    title: 'Módulo 6 — Plan de 21 días',
    desc: 'Hoja de ruta día a día para instalar todo lo anterior como hábito real y sostenido.'
  }];
  return <Section className="bg-bgLight py-20 px-4 sm:px-6 lg:px-8" data-id="element-155">
      <div className="max-w-5xl mx-auto" data-id="element-156">
        <div className="text-center mb-16" data-id="element-157">
          <span className="text-accentText font-sans font-semibold tracking-[0.08em] text-sm uppercase mb-4 block" data-id="element-158">
            🌙 MENTE EN CALMA, NOCHE EN PAZ™
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-headlineDark" data-id="element-159">
            6 Módulos + 5 Bonos — Todo para dormir bien desde esta noche
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-160">
          {modules.map((mod, i) => <div key={i} className="bg-white border border-cardBorder border-t-[3px] border-t-ctaFrom shadow-[0_4px_20px_rgba(192,132,252,0.12)] rounded-2xl p-6 transition-colors" data-id="element-161">
              <div className="flex items-start gap-4 mb-4" data-id="element-162">
                <span className="text-3xl" data-id="element-163">{mod.icon}</span>
                <h3 className="font-serif text-lg font-bold text-headlineDark pt-1" data-id="element-164">
                  {mod.title}
                </h3>
              </div>
              <p className="text-bodyOnLight mb-6 pl-12" data-id="element-165">{mod.desc}</p>
              <div className="pl-12" data-id="element-166">
                <span className="inline-flex items-center gap-2 bg-successGreen px-3 py-1.5 rounded-full text-xs font-medium text-successText" data-id="element-167">
                  <span data-id="element-168">✅</span> Incluido en ambos planes
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}